// Copyright 2018 Sorama B.V.

import { bindable } from "aurelia-framework";

export class SearchBar {
    heading = "Search the Sorama Portal";
    @bindable public filterText: string;
}
